import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tiktok-ad-list',
  templateUrl: './tiktok-ad-list.component.html',
  styleUrls: ['./tiktok-ad-list.component.css']
})
export class TikTokAdListComponent implements OnInit {
  allMerchants: any[] = [];
  tiktokMerchants: any[] = [];
  selectedMerchantId: string = '';
  batches: any[] = [];
  displayedColumns: string[] = ['merchantName', 'status', 'products', 'createdTime', 'nextRetry', 'actions'];

  pageSize = 20;
  currentPage = 1;
  totalBatches = 0;
  isActiveFilter: boolean | null = null;
  isLoading = false;
  merchantsLoading = false;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadMerchants();
  }

  loadMerchants() {
    this.merchantsLoading = true;
    this.http.get<any>('/api/Merchant/GetGrantedMerchants').subscribe(
      response => {
        this.allMerchants = Array.isArray(response) ? response : (response.data || []);
        // Filter for TikTok merchants (merchants with TikTok app credentials configured)
        this.tiktokMerchants = this.allMerchants.filter(m =>
          m.tikTokAccessToken != null && m.tikTokAccessToken != ''
        );
        this.merchantsLoading = false;
      },
      error => {
        console.error('Error loading merchants:', error);
        this.allMerchants = [];
        this.tiktokMerchants = [];
        this.merchantsLoading = false;
      }
    );
  }

  onMerchantChange() {
    this.currentPage = 1;
    this.loadBatches();
  }

  loadBatches() {
    if (!this.selectedMerchantId) {
      this.batches = [];
      this.totalBatches = 0;
      return;
    }

    this.isLoading = true;
    const params: any = {
      merchantId: this.selectedMerchantId,
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString()
    };

    if (this.isActiveFilter !== null) {
      params.isActive = this.isActiveFilter.toString();
    }

    this.http.get<any>('/api/TikTokAd/Query', { params }).subscribe(
      response => {
        this.batches = response.data || [];
        this.totalBatches = response.total || 0;
        this.isLoading = false;
      },
      error => {
        console.error('Error loading batches:', error);
        this.isLoading = false;
      }
    );
  }

  getStatusColor(displayStatus: string): string {
    if (displayStatus.includes('Success')) return 'success';
    if (displayStatus.includes('Retrying')) return 'warning';
    return 'danger';
  }

  toggleActiveFilter(active: boolean | null) {
    this.isActiveFilter = active;
    this.currentPage = 1;
    this.loadBatches();
  }

  viewBatchDetail(batchId: string) {
    this.router.navigate(['/tiktok-ad/detail', batchId]);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadBatches();
    }
  }

  nextPage() {
    if ((this.currentPage * this.pageSize) < this.totalBatches) {
      this.currentPage++;
      this.loadBatches();
    }
  }

  getMerchantName(merchantId: string): string {
    const merchant = this.allMerchants.find(m => m.merchantId === merchantId);
    return merchant ? merchant.name : merchantId;
  }
}
